import { CaoService } from 'src/app/services/cao.service';
import { Component, OnInit } from '@angular/core';
import { IpAddressService } from 'src/app/services/ip-address.service';
import * as XLSX from 'xlsx';
import { first } from 'rxjs';
import { MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-import-pfms-data',
  templateUrl: './import-pfms-data.component.html',
  styleUrls: ['./import-pfms-data.component.scss']
})
export class ImportPfmsDataComponent implements OnInit {

  dropDownList: { type: any, value: any }[];
  applicationSelected: any;
  xslxToJsonData: any[] = [];
  uploadFile: any;
  responseDate: any = [];
  showViewDocDialog: boolean = false;
  cols: any[];
  userID:any;
  ipAddress: any = '000.000.000';
  exportDataResponse: any = [];
  loadingExportResponse: boolean = false;

  constructor(
    private ipService: IpAddressService, 
    private caoService: CaoService, 
    private messageService: MessageService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService, 
    ) { }

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.getIP();

    this.activityRecordService.activityRecord(this.userID, 'Import PFMS Excel Sheets', '', new Date(), 'Success');

    this.dropDownList = [
      {
        type: 'Farmer Share To Vendor', value: 'FTV'
      },
      {
        type: 'Subsidy To Farmer', value: 'STF'
      },
      {
        type: 'Subsidy To Vendor', value: 'STV'
      },
      {
        type: 'Refund To Farmer', value: 'RTF'
      },
      {
        type: 'Stage 1', value: 'Stage1'
      },
      {
        type: 'Stage 2', value: 'Stage2'
      },
      {
        type: 'Stage 3', value: 'Stage3'
      },
    ]
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }

  onUpload(event, formcontrol, uploadElement) {
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    let file = event.files[0];
    this.uploadFile = file;
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary', cellText:false, cellDates:true });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet, {
          raw: false,
          dateNF:'yyyy-mm-dd',
        });
        return initial;
      }, {});
      const dataString = JSON.stringify(jsonData);
      this.xslxToJsonData = JSON.parse(dataString).data;
      if (!(this.xslxToJsonData)) {
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'The Uploaded file has invalid data "or" Multiple sheet data is not supported!' });
      }
    }
    reader.readAsBinaryString(file);
    uploadElement.clear();
  }

  onOpenDialog() {
    this.cols = [];
    let colHeaders = Object.keys(this.xslxToJsonData[0]);
    colHeaders.forEach(elem => {
      this.cols.push({ field: elem, header: elem })
    });
    this.showViewDocDialog = true;
  }

  clearUpload() {
    this.applicationSelected = undefined;
    this.xslxToJsonData = [];
  }

  onCloseDialog() {
    this.showViewDocDialog = false;
  }

  onApplicationTypeSelected(event) {
    this.applicationSelected = event.value;
  }

  submitApplication() {

    // Construct the Request Body
    let body = [];

    let jsonList = [];
    this.xslxToJsonData.forEach(obj => {
    if((this.applicationSelected.value === 'Stage1') || (this.applicationSelected.value === 'Stage2') || (this.applicationSelected.value === 'Stage3')) {
      jsonList.push({
        appID: obj['Scheme Specific ID'] ? obj['Scheme Specific ID'] : 0,
        // amount: obj['Challan Amount Deposited'] ? obj['Challan Amount Deposited'] : 0,
        ABY: obj['ABY'] ? obj['ABY'] : 0,
        TopUp: obj['Top Up'] ? obj['Top Up'] : 0,
        centre_share_amt: obj['Center Share Payment Amount'] ? obj['Center Share Payment Amount'] : 0,
        state_share_amt: obj['State Share Payment Amount'] ? obj['State Share Payment Amount'] : 0,
        TopUpPFMSPaymentDate: obj['Top Up PFMS Payment Date'] ? obj['Top Up PFMS Payment Date'] : '1900-01-01',
        pfmsPaymentDate: obj['PFMS Payment Date'] ? obj['PFMS Payment Date'] : '1900-01-01',
        status: obj['status'] ? obj['status'] : 0,
        remarks: obj['remarks'] ? obj['remarks'] : 0,
      })
    } else if((this.applicationSelected.value === 'STV') || (this.applicationSelected.value === 'STF')) {
      jsonList.push({
        appID: obj['Scheme Specific ID'] ? obj['Scheme Specific ID'] : obj['Scheme Specific Id'] ? obj['Scheme Specific Id'] : 0,
        // amount: obj['Challan Amount Deposited'] ? obj['Challan Amount Deposited'] : 0,
        centre_share_amt: obj['Center Share Payment Amount'] ? obj['Center Share Payment Amount'] : 0,
        state_share_amt: obj['State Share Payment Amount'] ? obj['State Share Payment Amount'] : 0,
        TopUp: obj['Top Up'] ? obj['Top Up'] : 0,
        TopUpPFMSPaymentDate: obj['Top Up PFMS Payment Date'] ? obj['Top Up PFMS Payment Date'] : '1900-01-01',
        pfmsPaymentDate: obj['PFMS Payment Date'] ? obj['PFMS Payment Date'] : '1900-01-01',
        status: obj['status'] ? obj['status'] : 0,
        remarks: obj['remarks'] ? obj['remarks'] : 0,
      })
    } else {
      jsonList.push({
        appID: obj['Scheme Specific ID'] ? obj['Scheme Specific ID'] : 0,
        amount: obj['Challan Amount Deposited'] ? obj['Challan Amount Deposited'] : 0,
        // state_share_amt: obj['Center Share Payment Amount'] ? obj['Center Share Payment Amount'] : 0,
        // centre_share_amt: obj['State Share Payment Amount'] ? obj['State Share Payment Amount'] : 0,
        status: obj['status'] ? obj['status'] : 0,
        remarks: obj['remarks'] ? obj['remarks'] : 0,
        pfmsPaymentDate: obj['PFMS Payment Date'] ? obj['PFMS Payment Date'] : '1900-01-01',
      })
    }
  })
    let reqBody = {
      list: jsonList,
      network_Id: this.ipAddress,
      terminal_Id: this.ipAddress,
      lotType: this.applicationSelected?.value
    }
    body.push(reqBody);

    // Categorize and Hit the API Accordingly
    if ((this.applicationSelected.value === 'STF') || (this.applicationSelected.value === 'STV')) {
      this.importMIPFMSSubsidyToFarmer_Vendor(body);
    } else if ((this.applicationSelected.value === 'FTV') || (this.applicationSelected.value === 'RTF')) {
      this.importMIPFMSFarmerShareToVendor_RefundToFarmer(body);
    } else if ((this.applicationSelected.value === 'Stage1') || (this.applicationSelected.value === 'Stage2') || (this.applicationSelected.value === 'Stage3')) {
      this.importPondPFMSSubsidyToFarmer(body);
    }
  }

  importMIPFMSSubsidyToFarmer_Vendor(body: any) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(body))
    }

    this.loader.start();
    this.caoService.importMIPFMSSubsidyToFarmer_Vendor(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.responseDate = data;
          this.loader.close();
          let isIncorrect = false;

          isIncorrect = this.responseDate.forEach((val, i) => {
            if(val?.IsCorrect == 0){
              isIncorrect = true;
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: this.responseDate[i].Message });
              return;
            }
            
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Submitted' });
          });
        
     
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
        }
      });
  }

  importMIPFMSFarmerShareToVendor_RefundToFarmer(body: any) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(body))
    }

    this.loader.start();
    this.caoService.importMIPFMSFarmerShareToVendor_RefundToFarmer(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.responseDate = data;
          this.loader.close();
          let isIncorrect = false;

          isIncorrect = this.responseDate.forEach((val, i) => {
            if(val?.IsCorrect == 0){
              isIncorrect = true;
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: this.responseDate[i].Message });
              return;
            }
            
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Submitted' });
          });
        
  
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

        }
      });
  }

  importPondPFMSSubsidyToFarmer(body: any) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(body))
    }

    this.loader.start();
    this.caoService.importPondPFMSSubsidyToFarmer(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.responseDate = data;
          this.loader.close();
          let isIncorrect = false;

          isIncorrect = this.responseDate.forEach((val, i) => {
            if(val?.IsCorrect == 0){
              isIncorrect = true;
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: this.responseDate[i].Message });
              return;
            }
            
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Submitted' });
          });
        
              
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

        }
      });
  }

  responseGridBackgroundColor(product){
    if (product.IsCorrect == 0) {
      return '#ff8080';
    } else return '#ffffff';
  }

}
